import React from 'react';
import PropTypes from 'prop-types';

import {oeInterfaceManager} from '../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../react-oe/oe-interface-adapter';
import OEIconCodes from '../../lib/oe-icon-codes';
import OEToolbox from '../../lib/tools/oe-toolbox';
import retardUpdate from '../../lib/react/update-retarder';
import OEIcon from '../elements/oe-icon';
import {OEIconButton} from '../elements/controls/oe-button';

export default class OEWidgetHeader extends React.PureComponent {

    constructor(props) {
        super(props);

        if(this.props.moduleId) this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.uiControllerType = this.resolveUIControllerType(this.props.uiControllerType);

        this.state = {
            title:      ''
        };

        this.updateLanguage = this.updateLanguage.bind(this);

        this.onToggle = this.onToggle.bind(this);
        this.onClick = this.onClick.bind(this);
    }

    resolveUIControllerType(type)   {
        if(typeof(type) === 'object')   return type ? this.resolveUIControllerType(type.value) : null;
        return typeof(type) === 'number' ? type : null;
    }

    setUIControllerType(uiControllerType, props)   {
        uiControllerType = this.resolveUIControllerType(uiControllerType);
        if(this.uiControllerType === uiControllerType) return;
        this.uiControllerType = uiControllerType;
        this.updateTitle(props);
    }

    componentWillReceiveProps(nextProps) {
		if(nextProps.uiControllerType !== this.props.uiControllerType)     {
            this.setUIControllerType(nextProps.uiControllerType, nextProps);
        }
        if(nextProps.title !== this.props.title || nextProps.titleId !== this.props.titleId)    {
            this.updateTitle(nextProps);
        }
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.languageChanged, this.updateLanguage);
    }

    onRelease()    {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.languageChanged, this.updateLanguage);
    }

    updateTitle(props)   {
        props = props || this.props;

        let titleId;
        if(!props.title && this.oe && this.oe.isReady())    {
            titleId = props.titleId ? props.titleId : (!props.title && this.uiControllerType !== null ? OEToolbox.getTitleStringIdForUIControllerType(this.uiControllerType) : undefined);
        }

        let title = titleId ? this.oe.sharedInterface.getLocalizedStringEnc(titleId) : (props.title ? props.title : '');
        this.setState({title: title});
    }

    updateLanguage()  {
        this.updateTitle();
    }

    updateState(released)   {
        if(!this.oe || !this.oe.isReady() || released === true) return;

        retardUpdate(this, () => {
            this.updateLanguage();
        });
    }

    renderHeader()  {
        let props;
        if(this.props.renderHeader || this.props.additionalButtons || this.props.centerBar)  {
            props = {...this.props};
            props.onToggle = this.onToggle;
        }

        if(this.props.renderHeader) return this.props.renderHeader(props);

        return (
            <div className="content" onClick={this.props.onHiddenGestureDetected ? this.onClick : null}>
                <div className="title">
                    {this.props.icon ? <OEIcon code={this.props.icon}/> : null}
                    <span className="title">{this.state.title}</span>
                </div>

                {this.props.draggableHandleElementId ? <div id={this.props.draggableHandleElementId} className="draggable-handle"/> : null}

                {this.props.centerBar ? <div className="center-bar">{this.props.centerBar(props)}</div> : null}

                <div className="buttons">
                    {this.props.onHelpBtnPressed ? <OEIconButton className={this.props.buttonClassName + ' help-btn'} icon={OEIconCodes.help} onPressed={this.props.onHelpBtnPressed}/> : null}

                    {this.props.additionalButtons ? this.props.additionalButtons(props) : null}

                    {this.props.onPinBtnPressed ? <OEIconButton className={this.props.buttonClassName + ' pin-btn'} icon={OEIconCodes.pin} activated={this.props.pinned} onPressed={this.props.onPinBtnPressed}/> : null}

                    {!this.props.onToggle && this.uiControllerType === null ? null :
                        <OEIconButton className={this.props.buttonClassName + ' close-btn'} icon={OEIconCodes.close} onPressed={this.onToggle}/>
                    }
                </div>
            </div>
        );
    }

    render()   {
        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>
                <div className={'std-label-text-color widget-header ' + this.props.className}>
                    {this.renderHeader()}
                    {this.props.headerSeparator ? <div className="std-separator-border-color separator"/> : null}
                </div>
            </React.Fragment>
        );
    }

    onToggle() {
        if(this.props.onToggle)    this.props.onToggle();

        if(this.uiControllerType === null || !this.oe || !this.oe.isReady()) return;
        this.oe.sharedInterface.setUIControllerVisible(false, {value: this.uiControllerType});
    }

    onClick()   {
        const currentTime = Date.now();
        if(this.clickCount === undefined || this.lastTime === undefined || currentTime - this.lastTime > 333)    {
            this.clickCount = 1;
        } else if(this.clickCount == 5) {
            if(this.props.onHiddenGestureDetected)  this.props.onHiddenGestureDetected();
            this.clickCount = 0;
        } else {
            this.clickCount++;
        }
        this.lastTime = currentTime;
    }
}

OEWidgetHeader.defaultProps = {
    className:                  '',
    moduleId:                   '',
    buttonClassName :           '',
    headerSeparator:            false
};

OEWidgetHeader.propTypes = {
    className:                  PropTypes.string,
    moduleId:                   PropTypes.string,
    buttonClassName:            PropTypes.string,
    draggableHandleElementId:   PropTypes.string,
    icon:                       PropTypes.string,
    title:                      PropTypes.string,
    titleId:                    PropTypes.string,
    headerSeparator:            PropTypes.bool,
    pinned:                     PropTypes.bool,
    renderHeader:               PropTypes.func,
    additionalButtons:          PropTypes.func,
    centerBar:                  PropTypes.func,
    onToggle:                   PropTypes.func,
    onHelpBtnPressed:           PropTypes.func,
    onPinBtnPressed:            PropTypes.func,
    onHiddenGestureDetected:    PropTypes.func
};